import { render, staticRenderFns } from "./osVr.vue?vue&type=template&id=5da9ec23&scoped=true&"
import script from "./osVr.vue?vue&type=script&lang=js&"
export * from "./osVr.vue?vue&type=script&lang=js&"
import style0 from "./osVr.vue?vue&type=style&index=0&id=5da9ec23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9ec23",
  null
  
)

export default component.exports